<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="mb-2">
      <PageTitle title="Ofertas da home" />
    </b-col>
    <b-col cols="12" class="mb-5">
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=1_Ge11SR-WA&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=36', 
            title: 'Categorias da home' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a
          class="btn btn-success"
          href="https://api.construp.com.br/assets/Categorias Home.pdf"
          target="_blank"
          download
          ><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a
        >
      </b-col>

    <b-col>
      <div class="ml-3">
        <label>Nome da categoria</label
        ><span class="maxCaractere">*Max 20 caracteres</span>
        <input
          type="text"
          v-model="menu"
          class="form-control mb-2"
          placeholder="Ex: Lançamentos, Promoções, Destaques"
          maxlength="20"
        />
        <div class="ml-2">
          <b-form-checkbox v-model="mostPromotion" class="mb-3" switch>
            Definir tempo limite para promoção
            <i
              class="fas fa-question-circle question-tool-tips"
              id="tooltip-target-2"></i>
            <BTooltip
              target="tooltip-target-2"
              placement="right"
              triggers="hover">
              Aqui você pode definir um tempo
              limite para as promoções na criação
              de cada categoria (opcional).
            </BTooltip>
          </b-form-checkbox>
          <div v-if="mostPromotion" class="d-flex">
            <label>Data:</label>
            <input
              type="date"
              :min="minDate"
              v-model="fieldsPromotion.datePromotion"
              class="mb-3 ml-1"
            >

            <label class="ml-3">Tempo:</label> <br>
            <input
              type="time"
              class="mb-3 ml-1"
              v-model="fieldsPromotion.timePromotion"
            >
          </div>
        </div>
        <!-- <label
          >Ordem da categoria ("Ordem que vai aparecer na listagem do
          app")</label -->
        
        <!-- <input
          type="number"
          disabled
          v-model="ordem"
          class="form-control mb-2"
          placeholder="Ex: 1, 2, 3..."
        /> -->
        <button
          v-if="whatClerkPermission()"
          class="btn btn-success btn-block"
          @click="save()"
        >
          <i class="fas fa-save mr-2"></i>
          Criar
        </button>
      </div>

      <div class="category-table mt-5">
        <label class="d-flex justify-content-center">Categoria(s) já cadastradas</label>
        <table v-if="items.length > 0" class="table table-striped table-responsive">
          <thead>
            <tr>
              <th scope="col">Ordem Cat.</th>
              <th scope="col" class="text-center">Nome</th>
              <th scope="col" class="text-center">Qtd Prod.</th>
              <th scope="col" class="text-center">Status</th>
              <!-- <th scope="col" class="text-center">Ordem</th> -->
              <th class="text-center">Funções</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in items" :key="i">
              <td>
                <i 
                  v-if="item.order != 1 && item.status == 0"
                  class="fas fa-angle-up fs-28 text-success arrowIncon"
                  @click="alterPosition('up', item, i -1)"
                ></i>
                <i 
                  v-if="ordemButton - 1 != item.order && item.status == 0"
                  class="fas fa-angle-down fs-28 ml-4 text-danger arrowIncon"
                  @click="alterPosition('down', item, i +1)"
                ></i>
              </td>
              <td class="text-center">
                <b-row>
                  <b-col cols="12">
                    <div>{{ item.name }}</div>
                  </b-col>
                  <b-col cols="12">
                    <div class="mt-3" v-if="item.limit_time">
                        <flip-countdown
                          :deadline="item.limit_time"
                          countdownSize=".9rem"
                          labelSize=".6rem"
                          v-show="item.disable_timer"
                          :labels="{
                            days: 'Dias',
                            hours: 'Hrs.',
                            minutes: 'Min.',
                            seconds: 'Seg.',
                          }"
                        >
                        </flip-countdown>
                    </div>
                  </b-col>
                </b-row>
              </td>
              <td class="text-center">{{ item.menu_product.length }}</td>
              <td class="text-center">{{ item.status == 0 ? 'Ativo' : 'Inativo' }}</td>
              <!-- <td class="text-center">{{ item.order }}</td> -->
              <td class="d-flex flex-wrap">
                <b-row>
                  <b-col cols="12" class="mb-2" align-self="center">
                    <b-button
                      @click="
                        $refs.modalProductsCategoryApp.toggleOpen({
                          item: item,
                        })
                      "
                      size="sm"
                      variant="warning"
                      v-b-tooltip.hover
                      title="Visualizar produtos"
                    >
                      <i class="fas fa-eye"></i>
                    </b-button>

                    <b-button
                      class="ml-1"
                      size="sm"
                      variant="info"
                      @click="addBanner(item.id)"
                      v-b-tooltip.hover
                      title="Adicionar banner na categoria"
                    >
                      <i class="fas fa-photo-video"></i>
                    </b-button>

                    <b-button
                      v-if="whatClerkPermission()"
                      class="ml-1"
                      size="sm"
                      variant="primary"
                      @click="editBy(item)"
                      v-b-tooltip.hover
                      title="Editar"
                    >
                      <i class="fas fa-pen"></i>
                    </b-button>

                    <b-button
                      v-if="whatClerkPermission()"
                      class="ml-1"
                      size="sm"
                      :variant="item.status == 0 ? 'danger' : 'info'"
                      @click="deleteMenu(item.id)"
                      v-b-tooltip.hover
                      :title="item.status == 0 ? 'Inativar' : 'Ativar'"
                    >
                      <i v-if="item.status == 0" class="fas fa-thumbs-down"></i>
                      <i v-else class="fas fa-thumbs-up"></i>
                    </b-button>

                    <b-button
                      @click="
                        $refs.modalAddProductsApp.toggleOpen({
                          item: item.menu_product,
                          menuId: item.id,
                        })
                      "
                      class="ml-1"
                      size="sm"
                      variant="success"
                      v-b-tooltip.hover
                      title="Incluir produtos"
                    >
                      <i class="fas fa-plus"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else class="d-flex justify-content-center">Nenhuma categoria cadastrada</p>
      </div>
    </b-col>

    <b-col>
      <FakeApp
        style="min-height: 800px; max-height: 800px; height: 800px"
        class="ml-4"
        :header-menu-color="fieldsColor.menuHeaderColor.hex8"
        :background-color="fieldsColor.backgroundColor.hex8"
        :icon-color="fieldsColor.iconColor.hex8"
        :font-color="fieldsColor.fontColor.hex8"
        :atualizar="atualizar"
        :items="items"
      />
    </b-col>
    <b-col cols="12" class="mt-5">
      <TableCategory
        :data="itemsInactive"
        @activeCategory="deleteMenu($event)"
        @editByCategory="editBy($event)"
        @getCategory="get()"
      />
    </b-col>

    <b-modal
      :title="`Editar categoria ${menuUp}`"
      size="lg"
      id="editCategory"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
      no-close-on-backdrop
    >
      <b-col cols="12" class="mb-2">
        <b-row>
          <b-col>
            <b-label>Nome da categoria</b-label>
            <b-input
              type="text"
              v-model="menuUp"
              class="mr-2"
              placeholder="Ex: Lançamentos, Promoções, Destaques"
            />
          </b-col>

          <b-col>
            <b-label>Botão (nome) "Ver mais"</b-label>
            <b-input
              type="text"
              v-model="seeMore"
              placeholder="Botão ver mais"
            />
          </b-col>
        </b-row>

        <hr class="mt-4">

        <b-row class="mt-4">
          <b-col cols="12" class="mb-3">
            <h4 class="text-center">Disposição dos produtos</h4>
          </b-col>

          <b-col cols="6">   
            <b-form-group label="Escholha a disposição dos produtos na home" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                v-model="selectedTypeDisposition"
                :options="options"
                :aria-describedby="ariaDescribedby"
                size="md"
                button-variant="outline-primary"
                buttons
              ></b-form-radio-group>
            </b-form-group>
          </b-col>

          <b-col cols="6">
            <div>
              <b-form-checkbox
                switch
                v-model="viewBtnHome"
              >
              Mostrar o botão "Ver mais" nos Produtos?
              </b-form-checkbox>
            </div>
            <b-input-group v-if="viewBtnHome" prepend="Rota:" class="mt-2">
              <b-form-input
                type="text"
                v-model="linkBtn"
                placeholder=""
                ></b-form-input>
            </b-input-group>
          </b-col>
        </b-row>

        <hr class="mt-4">
        <h4 class="text-center mb-4">DEFINIR PROMOÇÃO E DURAÇÃO</h4>
        <b-form-checkbox v-model="editByPromotion" class="mb-3" switch>
            Editar tempo para promoção?
            <i
              class="fas fa-question-circle question-tool-tips"
              id="tooltip-target-3"></i>
            <BTooltip
              target="tooltip-target-3"
              placement="right"
              triggers="hover">
              Deseja alterar o tempo ou definir uma promoção? (opcional).
            </BTooltip>
          </b-form-checkbox>
          <b-form-checkbox
            v-if="editByPromotion == false"
            v-model="disabledCountDown"
          >
            Desativar Promoção
          </b-form-checkbox>
          <b-row class="mt-3">
            <b-col cols="12" md="6" v-if="editByPromotion">
              <label>Data:</label>
              <input
                type="date"
                :min="minDate"
                v-model="fieldsPromotion.datePromotion"
                class="form-control mb-2"
              >
            </b-col>
            <b-col cols="12" md="6" v-if="editByPromotion">
              <label>Tempo:</label>
              <input
                type="time"
                class="form-control"
                v-model="fieldsPromotion.timePromotion"
              >
            </b-col>
          </b-row>
          
            <tr>
              <td>
                <div v-if="timer && timer != ''">
                  <flip-countdown
                    v-if="editByPromotion == false"
                    :deadline="timer"
                    countdownSize="1.5rem"
                    v-show="disabledCountDown == false"
                    labelSize="1rem"
                    :labels="{
                      days: 'Dias',
                      hours: 'Hrs.',
                      minutes: 'Min.',
                      seconds: 'Seg.',
                    }"
                  >
                  </flip-countdown>
                </div>
              </td>
            </tr>
          
        <b-button variant="success" class="mt-4" @click="sendUpdate()">
          <i class="fas fa-save mr-2"></i>
          Atualizar
        </b-button>
      </b-col>
    </b-modal>

    <b-modal
      title="Editar banner da categoria"
      size="lg"
      id="editBannerCategory"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer
    >
      <div class="row mb-4">
        <div class="col-9">
          <h4>BANNER 1</h4>
        </div>

        <div class="col-3 text-right mb-1">
          <button 
            @click="banner1.status = !banner1.status"
            :class="banner1.status == true ? 'btn btn-success' : 'btn btn-danger'"
          >
            {{banner1.status == true ? 'Ativo' : 'Inativo'}}
          </button>
        </div>

        <div class="col-8 mb-2">
          <label>Banner: (Tamanho recomendado: 630px / 187px)</label>
          <input type="file" ref="banner1" id="banner1" accept="image/png" @change="uploadImage('banner1')" class="form-control">
        </div>

        <div class="col-4 mb-2">
          <label>Banner acima/embaixo da categoria?:</label>

          <span class="mr-1">Acima</span>
          <input type="radio" name="banner1" value="true" v-model="banner1.banner_top">

          <span class="ml-4 mr-1">Embaixo</span>
          <input type="radio" name="banner1" value="false" v-model="banner1.banner_top">
        </div>

        <div class="col-12 text-center mb-2">
          <img :src="formatImg(banner1.img)" v-if="banner1.img != ''" alt="Banner 1" width="400px">
          <img :src="linkSemImg" v-else alt="Sem banner 1" width="400px">
        </div>

        <div class="col-8">
          <label>Link de redirecionamento do banner:</label>
          <input type="text" class="form-control" v-model="banner1.url" placeholder="Ex: https://www.minhaloja.com.br">
        </div>

        <div class="col-4">
          <label>No app vai levar para esse link?:</label>
          <input type="checkbox" class="form-control" v-model="banner1.external_link_app">
        </div>

        <div class="col-12 mt-4 text-center">
          <button class="btn btn-success" @click="saveBanner('banner1')">Salvar banner 1</button>
        </div>
      </div>

      <hr>

      <div class="row mt-4">
        <div class="col-12" v-if="this.banner1.id == null">
          <b-alert variant="danger" show>
            Salve o banner 1 para depois inserir o banner 2!
          </b-alert>
        </div>

        <div class="col-9">
          <h4 style="display: inline-flex;">BANNER 2 </h4>
          <span><b> (Opcional)</b></span>
        </div>

        <div class="col-3 text-right mb-1">
          <button 
            @click="banner2.status = !banner2.status"
            :class="banner2.status == true ? 'btn btn-success' : 'btn btn-danger'"
          >
            {{banner2.status == true ? 'Ativo' : 'Inativo'}}
          </button>
        </div>

        <div class="col-12 mb-2">
          <label>Banner: (Tamanho recomendado: 630px / 187px)</label>
          <input 
            type="file" 
            ref="banner2" 
            id="banner2" 
            accept="image/png" 
            @change="uploadImage('banner2')" 
            class="form-control"
            :disabled="this.banner1.id == null"
          >
        </div>

        <div class="col-12 text-center mb-2">
          <img :src="formatImg(banner2.img)" v-if="banner2.img != ''" alt="Banner 2" width="400px">
          <img :src="linkSemImg" v-else alt="Sem banner 2" width="400px">
        </div>

        <div class="col-8">
          <label>Link de redirecionamento do banner:</label>
          <input type="text" class="form-control" v-model="banner2.url" placeholder="Ex: https://www.minhaloja.com.br" :disabled="this.banner1.id == null">
        </div>

        <div class="col-4">
          <label>No app vai levar para esse link?:</label>
          <input type="checkbox" class="form-control" v-model="banner2.external_link_app" :disabled="this.banner1.id == null">
        </div>

        <div class="col-12 mt-4 text-center">
          <button class="btn btn-success" @click="saveBanner('banner2')" :disabled="this.banner1.id == null">Salvar banner 2</button>
        </div>
      </div>
    </b-modal>

    <modalProductsCategoryApp ref="modalProductsCategoryApp" />
    <modalAddProductsApp ref="modalAddProductsApp" @getProductSelect="get()" />
    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '../../../mixins/makeToast';
import PageTitle from '../../../components/PageTitle.vue';
import FakeApp from '@/views/lojista/customizations/ChangeColor/FakeApp.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import modalProductsCategoryApp from '../products/modalProductsCategoryApp.vue';
import modalAddProductsApp from '@/views/lojista/products/modalAddProductsApp.vue';
import TableCategory from '@/views/lojista/customizations/TableCategory.vue';
import VideoManual from '@/components/VideoManual.vue';
import FlipCountdown from 'vue2-flip-countdown';
export default {
  name: 'NewMenuHome',
  components: {
    PageTitle,
    FakeApp,
    modalProductsCategoryApp,
    modalAddProductsApp,
    TableCategory,
    VideoManual,
    FlipCountdown
  },
  mixins: [makeToast],
  data() {
    return {
      atualizar: false,
      editByPromotion: false,
      menu: '',
      active: true,
      menuUp: '',
      ordemButton: 0,
      ordemUp: 0,
      idUp: 0,
      ordem: 0,
      mostPromotion: false,
      items: [],
      itemsInactive: [],
      disabledCountDown: false,
      bannerMenuId: null,
      seeMore: '',
      linkBtn: null,
      viewBtnHome: false,
      status: false,
      selectedTypeDisposition: 'h',
      options: [
        { text: 'Vertical', value: 'v' },
        { text: 'Horizontal', value: 'h' },
        { text: 'Tabs', value: 't' },
      ],
      banner1: {
        id: null,
        img: '',
        url: null,
        banner_top: true,
        status: false,
        external_link_app: false,
        category_id: null,
        menu_home_id: null
      },
      banner2: {
        id: null,
        img: '',
        url: null,
        banner_top: true,
        status: false,
        external_link_app: false,
        category_id: null,
        menu_home_id: null
      },
      timer: '',
      fieldsPromotion: {
        datePromotion: '',
        timePromotion: '',
        currentTime: ''
      },
      fieldsColor: {
        menuHeaderColor: {},
        backgroundColor: {},
        iconColor: {},
        fontColor: {},
      },
      headers: [
        {
          key: 'name',
          label: 'Nome',
        },
        {
          key: 'menu_product',
          label: 'Qtde Prod',
        },
        {
          key: 'status',
          label: 'Status',
        },
        {
          key: 'order',
          label: 'Ordem',
        },
        {
          key: 'function',
          label: 'Funções',
        }
      ],
      linkSemImg: 'https://construp-imagens.s3.us-east-2.amazonaws.com/banner/sem_banner.png'
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    minDate() {
          const today = new Date().toISOString().split("T")[0];
          return today;
        }
  },
  mounted() {
    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', [
      'getMenusApp',
      'getMenuHomeBanner',
      'sendBannerMenu',
      'saveNewMenu',
      'editMenu',
      'showMenu',
      'inactivateMenuApp',
      'inativeCategory',
      'getCustomization',
      'saveCustomization',
    ]),

    addBanner(menuId) {

      this.limparBanner();

      this.bannerMenuId = menuId;

      this.banner1.menu_home_id = menuId;
      this.banner2.menu_home_id = menuId;
      
      this.$store.dispatch('startLoader');
      this.getMenuHomeBanner(menuId)
        .then((response) => {
          if(response.data[0]) {
            this.banner1.id = response.data[0].id;
            this.banner1.img = response.data[0].img;
            this.banner1.url = response.data[0].url;
            this.banner1.banner_top = response.data[0].banner_top == 1 ? true : false;
            this.banner1.status = response.data[0].status == 1 ? true : false;
            this.banner1.external_link_app = response.data[0].external_link_app == 1 ? true : false;
            this.banner1.category_id = response.data[0].category_id;
            this.banner1.menu_home_id = response.data[0].menu_home_id;
          }

          if(response.data[1]) {
            this.banner2.id = response.data[1].id;
            this.banner2.img = response.data[1].img;
            this.banner2.url = response.data[1].url;
            this.banner2.banner_top = response.data[1].banner_top == 1 ? true : false;
            this.banner2.status = response.data[1].status == 1 ? true : false;
            this.banner2.external_link_app = response.data[1].external_link_app == 1 ? true : false;
            this.banner2.category_id = response.data[1].category_id;
            this.banner2.menu_home_id = response.data[1].menu_home_id;
          }

          this.$bvModal.show('editBannerCategory');
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer o banner da categoria!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    saveBanner(bannerType) {
      
      var banner = {};
      if(bannerType == 'banner1') {
        if(this.banner1.img == '' || this.banner1.img == null) {
          this.makeToast('Opss', 'Informe o banner 1 para salvar!', 'danger');
          return;
        }
        banner = this.banner1;
      } else {
        if(this.banner2.img == '' || this.banner2.img == null) {
          this.makeToast('Opss', 'Informe o banner 2 para salvar!', 'danger');
          return;
        }

        this.banner2.banner_top = this.banner1.banner_top;
        banner = this.banner2;
      }

      this.$store.dispatch('startLoader');
      this.sendBannerMenu(banner)
        .then((response) => {
          this.$store.dispatch('endLoader');

          if(response.data.error == false) {
            this.makeToast('Sucesso', 'Banner salvo com sucesso!', 'success');

            if(this.bannerMenuId != null) {
              this.$bvModal.hide('editBannerCategory');
              this.addBanner(this.bannerMenuId);
            }
          } else {
            this.makeToast('Erro', 'Houve um erro ao salvar o banner da categoria!', 'danger');
          }
        })
        .catch(() => {
          this.$store.dispatch('endLoader');
          this.makeToast('Erro', 'Houve um erro ao salvar o banner da categoria!', 'danger');
        });
    },
    uploadImage(fileType) {
      const formData = new FormData();

      if(fileType == 'banner1') {
        this.imageSelected = this.$refs.banner1.files[0];
      } else {
        this.imageSelected = this.$refs.banner2.files[0];
      }

      formData.append('file', this.imageSelected);

      this.$store.dispatch('startLoader');
      this.$store.dispatch('files/uploadFileBannerHome', formData)
      .then((response) => {
        const file = response.data.data;
        
        if(fileType == 'banner1') {
          this.banner1.img = file;
          this.banner1.status = true;
        } else {
          this.banner2.img = file;
          this.banner2.status = true;
        }
      })
      .catch(() => {
        this.makeToast('Oops!', 'Não foi possível inserir o banner, tente novamente!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      });
    },
    formatImg(link) {
      return process.env.VUE_APP_FOTOS_AWS+'banner/'+link;
    },
    limparBanner() {
        this.banner1.id = null;
        this.banner1.img = '';
        this.banner1.url = null;
        this.banner1.banner_top = true;
        this.banner1.status = false;
        this.banner1.external_link_app = false;
        this.banner1.category_id = null;
        this.banner1.menu_home_id = null;

        this.banner2.id = null;
        this.banner2.img = '';
        this.banner2.url = null;
        this.banner2.banner_top = true;
        this.banner2.status = false;
        this.banner2.external_link_app = false;
        this.banner2.category_id = null;
        this.banner2.menu_home_id = null;
    },
    get() {
      this.$store.dispatch('startLoader');
      this.getMenusApp(this.userTypeId())
        .then((response) => {
          const data = response.data.data;
          if(data.length == 0) {
            this.ordem = 1;
            return;
          }

          let orders = [];
          this.items = [];
          this.itemsInactive = [];
          data.forEach(element => {
            let index = 0;
            if(element.status == 1) {
              this.itemsInactive.push(element);
              this.itemsInactive[index].order = null;
              index++;
            } else {
              this.items.push(element);
              orders.push(element.order)
            }
          });
            this.ordemButton = Math.max(...orders) + 1;
            if(this.orderButtom > 0) {
              this.ordem = this.itemsInactive.length += this.ordemButton;
            } else {
              this.ordem = this.ordemButton;
            }
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer as categorias!',
            'danger'
          );
        })
        .finally(() => {
          this.atualizar = !this.atualizar;
          this.$store.dispatch('endLoader');
        });

      this.getCustomization(this.userTypeId())
        .then((response) => {
          if (!response.data.data) return;
          this.handleColors(response.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    alterPosition(value, item, index) {
      const data = {
        name: '',
        order: value == 'up' ? item.order -1 : item.order +1,
        id: item.id,
        seccondOrder: value == 'up' ? this.items[index].order +1 : this.items[index].order -1,
        seccondId: this.items[index].id,
        construp_user_id: this.userTypeId(),
      };
        this.sendUpdate(data);
    },
    save() {
      const data = {
        name: this.menu,
        order: this.ordem,
        limit_time: this.editByPromotion ? this.fieldsPromotion.currentTime : this.fieldsPromotion.datePromotion + " " + this.fieldsPromotion.timePromotion,
        construp_user_id: this.userTypeId(),
        disable_timer: this.disabledCountDown == 1 ? true : false
      };

      this.$store.dispatch('startLoader');
      this.saveNewMenu(data)
        .then(() => {
          this.get();
          this.menu = '';
          this.ordem = 0;
          this.makeToast(
            'Sucesso',
            'Categoria cadastrada com sucesso!',
            'success'
          );
          this.$root.$emit('valid-available-app');
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao cadastrar a categoria!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    handleColors({ menuHeaderColor, backgroundColor, iconColor, fontColor }) {
      this.$set(this.fieldsColor.menuHeaderColor, 'hex8', menuHeaderColor);
      this.$set(this.fieldsColor.menuHeaderColor, 'hex', menuHeaderColor);

      this.$set(this.fieldsColor.backgroundColor, 'hex8', backgroundColor);
      this.$set(this.fieldsColor.backgroundColor, 'hex', backgroundColor);

      this.$set(this.fieldsColor.iconColor, 'hex8', iconColor);
      this.$set(this.fieldsColor.iconColor, 'hex', iconColor);

      this.$set(this.fieldsColor.fontColor, 'hex8', fontColor);
      this.$set(this.fieldsColor.fontColor, 'hex', fontColor);
    },
    deleteMenu(id) {
      this.$store.dispatch('startLoader');
      this.inativeCategory(id)
        .then(() => {
          this.get();
          this.$root.$emit('valid-available-app');
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao excluir a categoria!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    sendUpdate(value = false) {
      let data = {}
      this.fieldsPromotion.currentTime = this.fieldsPromotion.datePromotion + " " + this.fieldsPromotion.timePromotion;
      if(value == false) {
        
        if(this.viewBtnHome && !this.linkBtn) {
          this.makeToast(
            'Erro',
            'Favor inserir a rota do botão "Ver mais" do produto!',
            'danger'
          );
          return
        }

        data = {
          name: this.menuUp,
          order: this.ordemUp,
          button_see_more: this.seeMore,
          id: this.idUp,
          limit_time: this.editByPromotion ? this.fieldsPromotion.currentTime : this.fieldsPromotion.datePromotion + " " + this.fieldsPromotion.timePromotion,
          construp_user_id: this.userTypeId(),
          disable_timer: this.disabledCountDown == 1 ? true : false,
          disposition: this.selectedTypeDisposition,
          link_btn: this.linkBtn,
        };
      } else {
        data = value;
      }
      if(data.limit_time == 0) {
        data.limit_time = null;
      }
      if (data.disable_timer == null) {
            data.disable_timer = 0;
      }
      this.$store.dispatch('startLoader');
      this.editMenu(data)
        .then(() => {
          this.$bvModal.hide('editCategory');
          this.get();
          this.menuUp = '';
          this.ordemUp = 0;
          this.idUp = 0;
          this.selectedTypeDisposition = "h";
          this.linkBtn = null;
          this.viewBtnHome = false;

          this.makeToast(
            'Sucesso',
            'Categoria atualizada com sucesso!',
            'success'
          );
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao atualizar a categoria!',
            'danger'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    editBy(value) {
      this.menuUp = value.name;
      this.seeMore = value.button_see_more;
      this.ordemUp = value.order;
      this.idUp = value.id;
      this.timer = value.limit_time;
      this.disabledCountDown = value.disable_timer == 1 ? true : false;
      this.selectedTypeDisposition = value.disposition ? value.disposition : 'h';
      this.linkBtn = value.link_btn;
      this.viewBtnHome = value.link_btn != null ? true : false;

      this.$bvModal.show('editCategory');
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.CUSTOMIZACAO_HOME
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },
  },
};
</script>

<style scoped>
.maxCaractere {
  font-size: 10px;
  margin-left: 5px;
  color: rgb(136, 136, 136);
}

.arrowIncon {
  cursor: pointer;
}
</style>